import styled from "styled-components";

import AccentImage from "../../../public/themes/accent.svg";

const height = 128;
const width = 150;

export const Accents = () => (
  <AccentContainer>
    <TopComponent />
    <BottomComponent />
  </AccentContainer>
);

const AccentContainer = styled.div`
  pointer-events: none;
  z-index: var(--depth-low);
  width: 100%;
  max-width: var(--navigation-max-width);
  max-height: 100%;
  position: absolute;
  top: var(--navigation-height);
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
`;

const BaseComponent = styled(AccentImage)`
  pointer-events: none;
  z-index: var(--depth-low);
  position: absolute;
  display: block;
  opacity: var(--accent-opacity);
  user-select: none;
  pointer-events: none;
  transition: all var(--transition-speed-normal);
  width: ${width}px;
  height: ${height}px;
`;

const TopComponent = styled(BaseComponent)`
  top: var(--spacing-md);
  left: var(--spacing-md);
  color: var(--accent-top-color);
`;

const BottomComponent = styled(BaseComponent)`
  bottom: var(--spacing-md);
  right: var(--spacing-md);
  color: var(--accent-bottom-color);
`;

export default Accents;
